import { useState } from "react";
import { Moon, Sun } from "lucide-react";
import { cn } from "@/lib/utils";

export function ThemeToggle({ className }) {
  const [dark, setDark] = useState(() => document.documentElement.classList.contains("dark"));
  const toggle = () => {
    const next = !dark;
    document.documentElement.classList.toggle("dark", next);
    localStorage.setItem("gstdesk-theme", next ? "dark" : "light");
    setDark(next);
  };
  return (
    <button data-testid="theme-toggle-button" onClick={toggle} title={dark ? "Switch to light theme" : "Switch to dark theme"}
      className={cn("p-2 rounded-md border border-border text-muted-foreground hover:text-foreground hover:bg-secondary transition-colors", className)}>
      {dark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </button>
  );
}
